import axios from 'axios'
import authHeader from '@/services/auth-header'

const baseUrl = `${process.env.VUE_APP_API_URL}appscripts/discount-decisions`

class DiscountDecisionService {
  requests (params = {}) {
    return axios.get(`${baseUrl}/requests`, {
      headers: authHeader(),
      params
    })
  }

  request (requestId) {
    return axios.get(`${baseUrl}/requests/${requestId}`, { headers: authHeader() })
  }

  reconcile (requestId, enrollmentId) {
    return axios.post(`${baseUrl}/requests/${requestId}/reconcile`, { enrollment_id: enrollmentId }, { headers: authHeader() })
  }

  supportingDocument (requestId) {
    return axios.get(`${baseUrl}/requests/${requestId}/supporting-document`, {
      headers: authHeader(),
      responseType: 'blob'
    })
  }

  createRequest (payload, idempotencyKey) {
    const body = new FormData()
    Object.entries(payload).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') body.append(key, value)
    })
    return axios.post(`${baseUrl}/requests`, body, {
      headers: {
        ...authHeader(),
        'Idempotency-Key': idempotencyKey
      }
    })
  }

  searchEnrollments (query, signal) {
    return axios.get(`${baseUrl}/enrollments`, {
      headers: authHeader(),
      params: { query },
      signal
    })
  }

  context (enrollmentId, referenceDate) {
    return axios.get(`${baseUrl}/enrollments/${enrollmentId}/context`, {
      headers: authHeader(),
      params: { reference_date: referenceDate }
    })
  }

  parameters () {
    return axios.get(`${baseUrl}/parameters`, { headers: authHeader() })
  }

  parameterVersions () {
    return axios.get(`${baseUrl}/parameter-versions`, { headers: authHeader() })
  }

  createParameterVersion (payload) {
    return axios.post(`${baseUrl}/parameter-versions`, payload, { headers: authHeader() })
  }

  updateParameterVersion (versionId, payload) {
    return axios.put(`${baseUrl}/parameter-versions/${versionId}`, payload, { headers: authHeader() })
  }

  activateParameterVersion (versionId) {
    return axios.post(`${baseUrl}/parameter-versions/${versionId}/activate`, {}, { headers: authHeader() })
  }

  evaluate (payload) {
    return axios.post(`${baseUrl}/evaluate`, payload, { headers: authHeader() })
  }

  finalize (payload) {
    return axios.post(`${baseUrl}/finalize`, payload, { headers: authHeader() })
  }

  previewAddendum (payload) {
    return axios.post(`${baseUrl}/addendum/preview`, payload, { headers: authHeader() })
  }

  history (params = {}) {
    return axios.get(`${baseUrl}/history`, { headers: authHeader(), params })
  }
}

export default new DiscountDecisionService()
